import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { EMAIL_REG_EXP } from '../../shared/constants';
import { Box, Button, TextField, Typography } from '@material-ui/core';
import { ModalContainer, StyledPaper } from './UserRequestsStyles';

export type AssignAdminModalProps = {
  open: boolean;
  onClose: () => void;
  onAssign: (email: string) => void;
};

const schema = yup.object({
  email: yup
    .string()
    .required('Email is required')
    .matches(EMAIL_REG_EXP, 'Please enter a valid email address'),
});

const AssignAdminModal: React.FC<AssignAdminModalProps> = ({
  open,
  onClose,
  onAssign,
}) => {
  const { control, handleSubmit, reset } = useForm<{ email: string }>({
    resolver: yupResolver(schema),
    defaultValues: { email: '' },
  });

  const submit = (values: { email: string }) => {
    onAssign(values.email.trim());
    reset({ email: '' });
  };

  return (
    <ModalContainer open={open} onClose={onClose}>
      <StyledPaper>
        <Box mb={2}>
          <Typography variant="h6">Assign Admin</Typography>
        </Box>
        <form onSubmit={handleSubmit(submit)} noValidate>
          <Box display="flex" flexDirection="column">
            <Controller
              name="email"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Email"
                  variant="outlined"
                  fullWidth
                  required
                  error={!!error}
                  helperText={error?.message || ' '}
                />
              )}
            />
          </Box>
          <Box display="flex" justifyContent="flex-end" gridColumnGap={24}>
            <Button onClick={onClose} variant="text" color="primary">
              Cancel
            </Button>
            <Button type="submit" variant="text" color="primary">
              Assign
            </Button>
          </Box>
        </form>
      </StyledPaper>
    </ModalContainer>
  );
};

export default AssignAdminModal;
